import { render, staticRenderFns } from "./PluginExtension.vue?vue&type=template&id=82346b34"
import script from "./PluginExtension.vue?vue&type=script&lang=js"
export * from "./PluginExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports